import DocumentsWelcome from './styled';

export default DocumentsWelcome;
